import { listUnits, EMPTY_UNIT_FILTERS } from '@/features/geography/api'

let countryId: Promise<string | null> | null = null

/**
 * The unit a rollup is keyed on.
 *
 * A by-election is scoped to a constituency or county and its rollup is that unit's. A
 * national election has no scope unit, and its rollup is the COUNTRY row — the root of
 * the ltree, under which every station sits.
 *
 * This used to fall back to the ELECTION id, which is not a geography unit at all: the
 * request went out with the same uuid as both `electionId` and `unitId`, matched nothing,
 * and came back 404 with a message that looked like missing data rather than a bad call.
 *
 * Memoised at module scope — there is exactly one COUNTRY row and it does not change.
 */
export function nationalOr(scopeUnitId: string | null | undefined): Promise<string | null> {
  if (scopeUnitId) return Promise.resolve(scopeUnitId)
  if (!countryId) {
    countryId = listUnits({ ...EMPTY_UNIT_FILTERS, type: ['COUNTRY'] }, 0, 1)
      .then((page) => page.content[0]?.id ?? null)
      // A deployment with no geography imported yet has no country row. Null is the
      // honest answer; the caller renders "nothing counted yet" rather than erroring.
      .catch(() => null)
  }
  return countryId
}
